import { create } from "axios";

const ApiConnection = create({
  baseURL: `${process.env.REACT_APP_API}`,
});

export default ApiConnection;
